import { observer } from "mobx-react-lite";
import React from "react";
import { Icon, Table } from "semantic-ui-react";
import { IStudentProgressByCategory } from "../../../../app/models/studentProgress";

const StudentProgressByCategoryListItem: React.FC<{
  item: IStudentProgressByCategory;
}> = ({ item }) => {
  return (
    <Table.Row>
      <Table.Cell>{item.categoryName}</Table.Cell>
      <Table.Cell textAlign="center">{item.totalAnsweredQuestions}</Table.Cell>
      <Table.Cell textAlign="center">
        {item.totalWinAnsweredQuestions}
      </Table.Cell>
      <Table.Cell textAlign="center">
        {item.totalFailAnsweredQuestions}
      </Table.Cell>
      <Table.Cell textAlign="center">
        {Math.round(
          (item.totalWinAnsweredQuestions * 100) / item.totalAnsweredQuestions
        )}
        %{" "}
        {Math.round(
          (item.totalWinAnsweredQuestions * 100) / item.totalAnsweredQuestions
        ) >= 50 ? (
          <Icon name="thumbs up" color="green" />
        ) : (
          <Icon name="thumbs down" color="red" />
        )}
      </Table.Cell>
    </Table.Row>
  );
};

export default observer(StudentProgressByCategoryListItem);
